import {
  Truck, Snowflake, Boxes, Warehouse, Globe2, PackageCheck, Container,
} from "lucide-react";

export const NAV = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Brokerage", href: "#brokerage" },
  { label: "Work", href: "#work" },
  { label: "Network", href: "#network" },
  { label: "Process", href: "#process" },
  { label: "Careers", href: "#careers" },
  { label: "Contact", href: "#contact" },
];

export const HERO_BG =
  "https://images.unsplash.com/photo-1506577523015-5126b2a9b692?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export const TRUCK_IMG =
  "https://static.prod-images.emergentagent.com/jobs/8d90f641-0bec-4df1-aa7d-9defc9811b06/images/b11cca8c99f586c00405d0cb23742c90e20fa0459d5aca5ddad6485969554714.png";

export const STATS = [
  { value: 48, suffix: "M+", label: "Miles Driven Yearly" },
  { value: 99.2, suffix: "%", label: "On-Time Delivery", decimals: 1 },
  { value: 40, suffix: "+", label: "Cities Served" },
];

export const SERVICES = [
  {
    id: "cross-border",
    icon: Globe2,
    title: "Cross-Border Freight",
    short: "Seamless US–Canada–Mexico corridors with full customs orchestration.",
    image: "https://images.unsplash.com/photo-1585713181935-d5f622cc2415?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    features: ["Customs brokerage", "Bonded carriers", "C-TPAT certified", "Real-time border ETAs"],
    span: "md:col-span-7",
  },
  {
    id: "cold-chain",
    icon: Snowflake,
    title: "Refrigerated (Reefer)",
    short: "Temperature-controlled reefer fleet from -20°C to ambient.",
    image: "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    features: ["Multi-zone reefers", "24/7 temp telemetry", "FSMA compliant", "Pharma-grade lanes"],
    span: "md:col-span-5",
  },
  {
    id: "dry-van",
    icon: Container,
    title: "Dry Van Freight",
    short: "Enclosed dry van capacity for palletized and general freight.",
    image: "https://images.unsplash.com/photo-1760127831098-6a75c69ee79c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    features: ["53' dry vans", "Palletized & floor-loaded", "Sealed & secure", "Nationwide lanes"],
    span: "md:col-span-5",
  },
  {
    id: "ftl-ltl",
    icon: Truck,
    title: "FTL & LTL Trucking",
    short: "Full and less-than-truckload capacity that scales with your season.",
    image: "https://images.unsplash.com/photo-1641751976306-f2b9bb940bc9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    features: ["Dedicated lanes", "Flexible LTL pooling", "Dry van & reefer", "Guaranteed capacity"],
    span: "md:col-span-7",
  },
  {
    id: "warehousing",
    icon: Warehouse,
    title: "Warehousing",
    short: "Strategic distribution centers with WMS-integrated inventory.",
    image: "https://images.unsplash.com/photo-1740914994657-f1cdffdc418e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    features: ["Bonded storage", "Pick & pack", "Inventory sync", "Nationwide footprint"],
    span: "md:col-span-4",
  },
  {
    id: "cross-docking",
    icon: PackageCheck,
    title: "Cross-Docking",
    short: "Zero-storage transfer hubs that keep freight in constant motion.",
    image: "https://images.unsplash.com/photo-1721937127582-ed331de95a04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    features: ["Sub-24h turnaround", "Consolidation", "Deconsolidation", "Flow-through docks"],
    span: "md:col-span-4",
  },
  {
    id: "last-mile",
    icon: Boxes,
    title: "Last-Mile Delivery",
    short: "Final-mile precision with photo proof and live tracking.",
    image: "https://images.unsplash.com/photo-1611938845621-f7d331a14255?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    features: ["Proof of delivery", "Live driver tracking", "White-glove option", "Same-day windows"],
    span: "md:col-span-4",
  },
];

export const WORK = [
  { tag: "Cold-Chain", title: "Pharma corridor, Toronto → Dallas", metric: "99.9% temp integrity", image: "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { tag: "Cross-Border", title: "Laredo customs fast-lane program", metric: "-38% dwell time", image: "https://images.unsplash.com/photo-1585713181935-d5f622cc2415?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { tag: "Warehousing", title: "National retail DC consolidation", metric: "6 hubs, 1 network", image: "https://images.unsplash.com/photo-1721937127582-ed331de95a04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { tag: "Dry Van", title: "Retail replenishment, Chicago → Phoenix", metric: "100% dock-time hits", image: "https://images.unsplash.com/photo-1760127831098-6a75c69ee79c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { tag: "Last-Mile", title: "Metro same-day delivery grid", metric: "97% on-window", image: "https://images.unsplash.com/photo-1641751976306-f2b9bb940bc9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
];

export const CLIENTS = ["NORTHWIND", "CULLIGAN", "MERIDIAN", "VANTAGE", "GOODYARD", "PRAIRIE CO", "ATLAS FOODS", "RYDELL"];

export const TESTIMONIALS = [
  { name: "Karen Alvarez", role: "VP Supply Chain, Meridian Foods", quote: "Conexa Relay turned our fragile cold-chain into our most reliable lane. Border crossings that used to eat a day now clear before lunch.", rating: 5 },
  { name: "Devin Okafor", role: "Logistics Director, Atlas Retail", quote: "The visibility is unreal. One dashboard, every truck, every dock. We cut dwell time by nearly 40% in a quarter.", rating: 5 },
  { name: "Priya Nair", role: "COO, Vantage Industrial", quote: "Heavy-haul permits used to terrify us. Their team handled routing, escorts and paperwork flawlessly across three states.", rating: 5 },
  { name: "Marcus Bell", role: "Founder, Prairie Provisions", quote: "From a handshake to a fully managed network in weeks. They scale exactly when our season spikes.", rating: 5 },
];

export const TEAM = [
  { name: "Elena Marquez", role: "Chief Executive Officer", image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { name: "James Whitfield", role: "Head of Fleet Operations", image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { name: "Sofia Chen", role: "Director, Cross-Border", image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { name: "Andre Dubois", role: "VP of Technology", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
];

export const PROCESS = [
  { step: "01", title: "Request & Quote", desc: "Tell us the lane, cargo and timeline. Get a transparent, all-in quote the same day." },
  { step: "02", title: "Route Engineering", desc: "We plan optimal corridors, permits and customs before a wheel turns." },
  { step: "03", title: "Dispatch & Track", desc: "Live GPS, temperature and ETA telemetry from pickup to the final dock." },
  { step: "04", title: "Delivered & Verified", desc: "Photo proof, signed BOL and performance reporting close every load." },
];

export const PRICING = [
  { name: "Spot", price: "Per Load", desc: "On-demand capacity when you need it.", features: ["Instant quotes", "Live tracking", "Dry van & reefer", "Email support"], highlight: false },
  { name: "Managed", price: "Custom", desc: "Dedicated lanes for growing shippers.", features: ["Dedicated capacity", "Priority dispatch", "Account manager", "Weekly reporting"], highlight: false },
  { name: "Enterprise", price: "Let's Talk", desc: "End-to-end managed logistics.", features: ["Warehousing & cross-dock", "Custom integrations (TMS/WMS)", "24/7 control tower", "SLA guarantees"], highlight: false },
];

export const FAQS = [
  { q: "Which regions do you cover?", a: "We operate cross-border lanes across the US, Canada and Mexico, plus partner networks reaching 12 countries." },
  { q: "How fast can I get a quote?", a: "Most quotes are returned the same business day. Spot loads often within the hour via our instant quote form." },
  { q: "Do you handle customs and permits?", a: "Yes. We are C-TPAT certified and manage brokerage, bonded transit and over-dimensional permitting end to end." },
  { q: "Can I track my shipment in real time?", a: "Every load includes live GPS, temperature telemetry for reefers, and predictive ETAs in one dashboard." },
  { q: "What temperature ranges do reefers support?", a: "Our multi-zone reefer fleet holds anywhere from -20°C deep-freeze to controlled ambient, FSMA and pharma compliant." },
  { q: "Do you offer warehousing too?", a: "Yes — bonded storage, pick & pack and cross-dock hubs integrate directly with your transport lanes." },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);
